// import React, { useEffect, useState } from 'react';
// import { Card, Container, Row, Col, Button, Badge, Modal } from 'react-bootstrap';
// import './BuyerSuccessfulBids.css';

// export default function BuyerSuccessfulBids() {
//   const [successfulBids, setSuccessfulBids] = useState([]);
//   const [selectedSeller, setSelectedSeller] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const user = JSON.parse(sessionStorage.getItem('user'));
//   const buyerId = user?.id;

//   const handleContactSeller = (offer) => {
//     setSelectedSeller(offer);
//     setShowModal(true);
//   };

//   useEffect(() => {
//     const fetchSuccessfulBids = async () => {
//       try {
//         const res = await fetch(`https://vyaparapi.emedha.in/api/buyer/confirmed-bids/${buyerId}`);
//         const data = await res.json();
//         setSuccessfulBids(data);

//         console.log(data)
//       } catch (err) {
//         console.error('❌ Error fetching confirmed bids:', err);
//       }
//     };

//     if (buyerId) fetchSuccessfulBids();
//   }, [buyerId]);



//   const handlePayRemaining = async (offer) => {
//   try {
//     const res = await fetch('https://vyaparapi.emedha.in/api/buyer/pay-remaining-90per', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         bid_id: offer.bid_id,
//         seller_id: offer.seller_id,
//       }),
//     });

//     const data = await res.json();
//     if (data.success) {
//       alert('✅ Payment successful!');
//       // Refresh the data
//       const res = await fetch(`https://vyaparapi.emedha.in/api/buyer/90per/confirmed-bids/${buyerId}`);
//       const updated = await res.json();
//       setSuccessfulBids(updated);
//     } else {
//       alert(`❌ ${data.message}`);
//     }
//   } catch (err) {
//     console.error('❌ Error during payment:', err);
//     alert('❌ Payment failed. Try again.');
//   }
// };


//   return (
//     <Container className="my-2 buyer-successful-bids">
//       <h3 className="section-title text-center mb-4" style={{ color: '#062d59', fontSize:'25px' }}>
//         🎯 Buyer Successful Bids
//       </h3>

//       {successfulBids.length === 0 ? (
//         <p className="text-center text-muted">No successful bids found.</p>
//       ) : (
//  <Row>
//   {successfulBids
//     .filter(bid => Array.isArray(bid.accepted_sellers) && bid.accepted_sellers.length > 0)
//     .map((bid, i) => (
//       <Col md={4} key={bid.bid_id} className="mb-4">
//         <Card className="bid-card" style={{ borderColor: '#062d59' }}>
//           <Card.Body>
//             <h5 className="mb-3 text-primary">
//               <strong>🆔 Bid ID:</strong> {bid.bid_id}
//             </h5>
//             <Row className="mb-2">
//               <Col md={6}><strong>📦 Category:</strong> {bid.category} / {bid.sub_category}</Col>
//               <Col md={6}><strong>💰 Price Range:</strong> ₹{bid.price_from} - ₹{bid.price_to}</Col>
//             </Row>
//             <Row>
//               <Col md={6}><strong>🔧 Warranty:</strong> {bid.warranty}</Col>
//               <Col md={6}><strong>🧩 Specs:</strong> {bid.selected_specs}</Col>
//             </Row>
//             <p className="text-muted mt-2">🕒 Created: {new Date(bid.created_at).toLocaleString()}</p>

//             <h6 className="text-secondary mt-4">Accepted Seller Offers</h6>
//             <Row>
//               {bid.accepted_sellers.map((offer) => (
//                 <Col md={12} key={offer.id} className="mt-3">
//                   <Card className="offer-card text-center h-100" style={{ borderColor: '#e3080c' }}>
//                     <Card.Body>
//                       <h5 className="offer-price">₹{offer.seller_offer}</h5>
//                       <p className="text-muted small">🕒 {new Date(offer.created_at).toLocaleString()}</p>
//                       <Badge bg="success" className="mb-3">Accepted</Badge>
//                       <br />
//                       <Button
//                         variant="danger"
//                         size="sm"
//                         onClick={() => handleContactSeller(offer)}
//                       >
//                         Contact Seller
//                       </Button>


// {offer.payment_status !== 'paid' && (
//   <Button
//     variant="success"
//     size="sm"
//     className="m-1"
//     onClick={() => handlePayRemaining(offer)}
//     style={{marginLeft:20}}
//   >
//     Pay Remaining 90%
//   </Button>
// )}
// <br />
//                     </Card.Body>
//                   </Card>
//                 </Col>
//               ))}
//             </Row>
//           </Card.Body>
//         </Card>
//       </Col>
//     ))
//   }
// </Row>

//       )}

//       <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//         <Modal.Header closeButton style={{ backgroundColor: '#062d59', color: '#fff' }}>
//           <Modal.Title>Seller Information</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedSeller && (
//             <>
//               <h5 className="text-primary">{selectedSeller.seller_name}</h5>
//               <p><strong>Email:</strong> {selectedSeller.seller_email}</p>
//               <p><strong>Mobile:</strong> {selectedSeller.seller_mobile}</p>
//               <hr />
//               <p><strong>Business:</strong> {selectedSeller.business_category}</p>
//               <p><strong>Location:</strong> {selectedSeller.city}, {selectedSeller.state}</p>
//               <p><strong>GST:</strong> {selectedSeller.gst_number || 'N/A'}</p>
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// }



import React, { useEffect, useState } from 'react';
import { Card, Container, Row, Col, Button, Badge, Modal } from 'react-bootstrap';
import './BuyerSuccessfulBids.css';

export default function BuyerSuccessfulBids() {
  const [successfulBids, setSuccessfulBids] = useState([]);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'));
  const buyerId = user?.id;

  const handleContactSeller = (offer) => {
    setSelectedSeller(offer);
    setShowModal(true);
  };

  useEffect(() => {
    const fetchSuccessfulBids = async () => {
      try {
        const res = await fetch(`https://vyaparapi.emedha.in/api/buyer/confirmed-bids/${buyerId}`);
        const data = await res.json();
        setSuccessfulBids(data);

        console.log(data)
      } catch (err) {
        console.error('❌ Error fetching confirmed bids:', err);
      }
    };

    if (buyerId) fetchSuccessfulBids();
  }, [buyerId]);



  const handlePayRemaining = async (offer) => {
  try {
    const res = await fetch('https://vyaparapi.emedha.in/api/buyer/pay-remaining-90per', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        bid_id: offer.bid_id,
        seller_id: offer.seller_id,
      }),
    });

    const data = await res.json();
    if (data.success) {
      alert('✅ Payment successful!');
      // Refresh the data
      const res = await fetch(`https://vyaparapi.emedha.in/api/buyer/90per/confirmed-bids/${buyerId}`);
      const updated = await res.json();
      setSuccessfulBids(updated);
    } else {
      alert(`❌ ${data.message}`);
    }
  } catch (err) {
    console.error('❌ Error during payment:', err);
    alert('❌ Payment failed. Try again.');
  }
};


return (
  <Container className="buyer-successful-bids my-5">
    <h2 className="text-center mb-4 section-title" style={{fontSize:'25px', textAlign:'center'}}>🎯 Buyer Successful Bids</h2>

    {successfulBids.length === 0 ? (
      <p className="text-center text-muted">No successful bids found.</p>
    ) : (
      <Row>
        {successfulBids
          .filter(bid => Array.isArray(bid.accepted_sellers) && bid.accepted_sellers.length > 0)
          .map(bid => (
            <Col md={6} lg={4} key={bid.bid_id} className="mb-4">
              <Card className="bid-card-modern">
                <Card.Body>
                  <h5 className="text-primary mb-3">
                    <i className="bi bi-box-fill me-2"></i>Bid ID: {bid.bid_id}
                  </h5>
                  <p><strong>Category:</strong> {bid.category} / {bid.sub_category}</p>
                  <p><strong>Price:</strong> ₹{bid.price_from} - ₹{bid.price_to}</p>
                  <p><strong>Warranty:</strong> {bid.warranty}</p>
                  <p><strong>Specs:</strong> {bid.selected_specs}</p>
                  <p className="text-muted small">Created: {new Date(bid.created_at).toLocaleString()}</p>

                  <h6 className="mt-4 mb-2" style={{ color: '#062d59' }}>Accepted Seller Offers</h6>

                  {bid.accepted_sellers.map((offer, idx) => (
                    <Card key={idx} className="offer-card-modern mb-3">
                      <Card.Body>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h5 style={{ color: '#e3080c' }}>₹{offer.seller_offer}</h5>
                          <Badge bg="success">Accepted</Badge>
                        </div>
                        <p className="small text-muted">
                          <i className="bi bi-clock me-1"></i>
                          {new Date(offer.created_at).toLocaleString()}
                        </p>

                        <div className="d-flex gap-2 flex-wrap">
                          <Button
                            variant="outline"
                            style={{ borderColor: '#e3080c', color: '#e3080c' }}
                            size="sm"
                            onClick={() => handleContactSeller(offer)}
                          >
                            <i className="bi bi-envelope-fill me-1"></i>Contact
                          </Button>

                          {offer.payment_status !== 'paid' && (
                            <Button
                              variant="outline"
                              style={{ borderColor: '#062d59', color: '#062d59' }}
                              size="sm"
                              onClick={() => handlePayRemaining(offer)}
                            >
                              <i className="bi bi-wallet-fill me-1"></i>Pay 90%
                            </Button>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                </Card.Body>
              </Card>
            </Col>
          ))}
      </Row>
    )}

    {/* Modal for Seller Info */}
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton style={{ backgroundColor: '#062d59', color: '#fff' }}>
        <Modal.Title>Seller Information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedSeller && (
          <>
            <p><strong>Name:</strong> {selectedSeller.seller_name}</p>
            <p><strong>Email:</strong> {selectedSeller.seller_email}</p>
            <p><strong>Mobile:</strong> {selectedSeller.seller_mobile}</p>
            <hr />
            <p><strong>Business:</strong> {selectedSeller.business_category}</p>
            <p><strong>Location:</strong> {selectedSeller.city}, {selectedSeller.state}</p>
            <p><strong>GST:</strong> {selectedSeller.gst_number || 'N/A'}</p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  </Container>
);


}

